<template>
    <ob1-popin-modal-visual
        :id="id"
        :aria-labelledby="id"
        :show-close-button="false"
        additional-classes="d-webview-none"
    >
        <template #visual>
            <div class="ob1-modal-img d-webview-none">
                <div class="image-crop">
                    <img
                        :src="visual.src"
                        :alt="visual.alt"
                    >
                </div>
            </div>
        </template>
        <template #content>
            <h4 v-html="title" />
            <ob1-message-alerte
                v-if="description"
                class="pt-1"
                :type="'info'"
                :is-simple-alerte="false"
                :title="description"
            />

            <div class="ob1-modal-footer-visual">
                <div class="row d-flex align-items-center">
                    <div class="order-2 order-md-1 col-12 col-md-6 pt-2 pt-md-0">
                        <ob1-liens
                            :text="withoutDeviceSection.button.label"
                            :href="withoutDeviceSection.button.href"
                            :is-link="true"
                            :data-oevent-category="withoutDeviceSection.button.tmsDTO.tagZone"
                            :data-oevent-action="withoutDeviceSection.button.tmsDTO.tagName"
                            :data-oevent-label="withoutDeviceSection.button.href"
                        />
                    </div>
                    <div class="order-1 order-md-2 col-12 col-md-6 px-0">
                        <ob1-boutons
                            :label="withDeviceSection.button.label"
                            :is-primary="true"
                            :is-button="false"
                            :href="withDeviceSection.button.href"
                            :data-oevent-category="withDeviceSection.button.tmsDTO.tagZone"
                            :data-oevent-action="withDeviceSection.button.tmsDTO.tagName"
                            :data-oevent-label="withDeviceSection.button.href"
                        />
                    </div>
                </div>
            </div>
        </template>
    </ob1-popin-modal-visual>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: false,
            default: "withDevicePopIn"
        },
        title: {
            type: String,
            required: false,
            default: ""
        },
        description: {
            type: String,
            required: false,
            default: ""
        },
        visual: {
            type: Object,
            required: true
        },
        withDeviceSection: {
            type: Object,
            required: true
        },
        withoutDeviceSection: {
            type: Object,
            required: true
        }
    },
    methods: {
        show() {
            $('#' + this.id).modal('show');
        },
    }

}
</script>

<style scoped lang="scss">
@media (min-width: 736px) {
    .image-crop {
        width: 405px;
        overflow: hidden;
        position: relative;
    }

    .image-crop img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
</style>
